// removed by extract-text-webpack-plugin
module.exports = {"default-container":"custom-flyer-picker__default-container__1OXoy","section-container":"custom-flyer-picker__section-container__2iMr7","first-tip":"custom-flyer-picker__first-tip__1LCl0","second-tip":"custom-flyer-picker__second-tip__4kXQG","edit-icon":"custom-flyer-picker__edit-icon__3tutR"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/custom-flyer-picker.scss
// module id = 1714
// module chunks = 1